export const ROUTE_FEED = 'ROUTE_FEED'
export const ROUTE_FEEDS = 'ROUTE_FEEDS'
